/**
 * Media Gallery
 */

// Vendors
import $ from 'jquery';
import carousel from '../framework/carousel';

// Init carousel
$('[data-media-gallery]').each((index, element) => {
  const galleryId = $(element).data('media-gallery');
  const galleryFormat = $(element).data('media-gallery-format');
  const gallerySelector = `[data-media-gallery="${galleryId}"]`;

  const gallerySettings = {
    autoplay: false,
    infinite: true,
    dots: false,
    speed: 500,
    cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
    asNavFor: `${gallerySelector} [data-media-gallery-carousel]`,
    arrows: false,
    adaptiveHeight: true
  };

  const galleryNavSettings = {
    ...gallerySettings,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    prevArrow:
      '<button type="button" class="slick-arrow slick-prev module-hover-root"><span class="icon icon--lg perc-icon-arrow-left media-gallery__arrow"></span></button>',
    nextArrow:
      '<button type="button" class="slick-arrow slick-next module-hover-root"><span class="icon icon--lg perc-icon-arrow-right media-gallery__arrow"></span></button>',
    responsive: [
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  if (galleryFormat === 'horizontal') {
    galleryNavSettings['slidesToShow'] = 4;
    galleryNavSettings['responsive'] = [
      {
        breakpoint: 576,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 }
      }
    ];
  }

  carousel(`${gallerySelector} [data-media-gallery-media]`, gallerySettings);
  carousel(`${gallerySelector} [data-media-gallery-content]`, gallerySettings);
  carousel(`${gallerySelector} [data-media-gallery-nav]`, galleryNavSettings);
});

$('[data-media-gallery-media]').on(
  'beforeChange',
  (event, slick, currentSlide, nextSlide) => {
    const videoPlayer = $(event.currentTarget).find('.video-player');

    if (!videoPlayer) return false;

    $(videoPlayer).removeClass('video-player--playing');
    $(videoPlayer).find('.video-player__iframe').remove();
  }
);

$('[data-media-gallery-content]').on(
  'afterChange',
  (event, slick, currentSlide, nextSlide) => {
    const contentDescription = $(event.currentTarget).find(
      '[data-media-gallery-description]'
    );

    if (contentDescription) $(contentDescription).scrollTop(0);
  }
);
